import { render } from "./FacialHarmonizationContentEs.vue?vue&type=template&id=a76fe660&scoped=true"
import script from "./FacialHarmonizationContentEs.vue?vue&type=script&lang=js"
export * from "./FacialHarmonizationContentEs.vue?vue&type=script&lang=js"

import "./FacialHarmonizationContentEs.vue?vue&type=style&index=0&id=a76fe660&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a76fe660"]])

export default __exports__